import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'running_experience'

export default function RunningExperiencePage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value === 'female' || value === 'male' ? value : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How would you describe your current running experience?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.runningExperience.heading')}
      buttons={[
        {
          text: t('pages.onboarding.runningExperience.options.beginner.title'),
          value: 'beginner',
          subtext: t(
            'pages.onboarding.runningExperience.options.beginner.description',
          ),
        },
        {
          text: t('pages.onboarding.runningExperience.options.novice.title'),
          value: 'novice',
          subtext: t(
            'pages.onboarding.runningExperience.options.novice.description',
          ),
        },
        {
          text: t(
            'pages.onboarding.runningExperience.options.intermediate.title',
          ),
          value: 'intermediate',
          subtext: t(
            'pages.onboarding.runningExperience.options.intermediate.description',
          ),
        },
        {
          text: t('pages.onboarding.runningExperience.options.advanced.title'),
          value: 'advanced',
          subtext: t(
            'pages.onboarding.runningExperience.options.advanced.description',
          ),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
      withLogin={window.ReactNativeWebView ? false : true}
    />
  )
}
